import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
const Tab = styled.button `
  font-size: 20px;
  padding: 10px 60px;
  cursor: pointer;
  opacity: 0.6;
  background: white;
  border: 0;
  outline: 0;
  ${(props) => props.active &&
    `
    border-bottom: 2px solid black;
    opacity: 1;
  `}
`;
const ButtonGroup = styled.div `
  display: flex;
`;
export function tabGroup(props) {
    const [active, setActive] = useState(props.types[0]);
    return (_jsx(_Fragment, { children: _jsx(ButtonGroup, { children: props.types.map(type => (_jsx(Tab, { active: active === type, onClick: () => {
                    props.setType(type);
                    setActive(type);
                }, children: type }, type))) }) }));
}
